import React from 'react';
import PropTypes from 'prop-types';

/*
 * Pembungkus halaman situs publik. TIDAK memakai withStyles(Layout.css).
 *
 * Layout.css meng-@import Common.css + responsive-common.css, dan
 * isomorphic-style-loader menyisipkan hasilnya sebagai <style id="css"> inline
 * sebesar 68,8 KB di SETIAP halaman publik — padahal komponen ini tidak memakai
 * satu pun class dari file itu (lihat render: cuma sebuah <div>). Aturan global
 * yang sama sudah dimuat lewat <link> /css/app-common.css dan
 * app-responsive-common.css di Html.js, jadi ini murni duplikat.
 */
class Layout extends React.Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
  };

  render() {
    return (
      <div>
        {this.props.children}
      </div>
    );
  }
}

export default Layout;
